import { type Cell, flexRender } from '@tanstack/react-table'
import React from 'react'

import Icon from '../../../Icon/Icon'
import Text from '../../../Text/Text'
import { useCellSelection } from '../../features/CellSelectionFeature'
import { getCommonPinningStyles } from '../../utils/getCommonPinningStyles'
import { TableCell } from './DataTableCell.styles'

interface DataTableCellProps<TData> {
  cell: Cell<TData, unknown>
  isDisabled?: boolean
  rowHeight: number
  withBorder?: boolean
}

export const DataTableCell = <TData,>({
  cell,
  isDisabled,
  rowHeight,
  withBorder,
}: DataTableCellProps<TData>) => {
  const { column } = cell

  const { isSelectable, isSelected, handleCellClick } = useCellSelection(cell)

  return (
    <TableCell
      data-e2e={`column-${cell.column.id}`}
      data-selected={isSelected}
      data-cell-selectable={isSelectable}
      data-cell-disabled={
        (isDisabled && !cell.column.columnDef.meta?.excludeFromDisableState) ?? false
      }
      $rowHeight={rowHeight}
      $withBorder={withBorder}
      id={cell.id}
      columnId={cell.column.id}
      style={{
        ...getCommonPinningStyles(column),
        justifyContent: cell.column.columnDef.meta?.align ?? 'start',
      }}
      onClick={handleCellClick}
    >
      <Text as="div" ellipsis noWrap>
        {isSelected && <Icon data-e2e="data-table-cell-selected--icon" name="check" />}

        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </Text>
    </TableCell>
  )
}
